module.exports = __webpack_public_path__ + "img/titulo.9258a6ab.png";